var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column col-md-12 mt-5 mb-3"},[_c('div',{staticClass:"text-title mt-5"},[_vm._v("Email: "),_c('a',{attrs:{"href":'mailto:' + _vm.mEmail}},[_vm._v(_vm._s(_vm.mEmail))])]),_vm._v(" "),_c('div',{staticClass:"text-title"},[_vm._v("© "+_vm._s(_vm.mText)+" All Rights Reserved.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12e625ab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RowFooter.vue
// module id = null
// module chunks = 